var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLIosGIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9391 11.5953C14.9297 9.875 15.7078 8.57656 17.2828 7.62031C16.4016 6.35938 15.0703 5.66563 13.3125 5.52969C11.6484 5.39844 9.82969 6.5 9.16406 6.5C8.46094 6.5 6.84844 5.57656 5.58281 5.57656C2.96719 5.61875 0.1875 7.6625 0.1875 11.8203C0.1875 13.0484 0.4125 14.3172 0.8625 15.6266C1.4625 17.3469 3.62812 21.5656 5.8875 21.4953C7.06875 21.4672 7.90312 20.6563 9.44062 20.6563C10.9312 20.6563 11.7047 21.4953 13.0219 21.4953C15.3 21.4625 17.2594 17.6281 17.8312 15.9031C14.775 14.4641 14.9391 11.6844 14.9391 11.5953ZM12.2859 3.89844C13.5656 2.37969 13.4484 0.996875 13.4109 0.5C12.2812 0.565625 10.9734 1.26875 10.2281 2.13594C9.40781 3.06406 8.925 4.2125 9.02813 5.50625C10.2516 5.6 11.3672 4.97188 12.2859 3.89844Z",
    fill: "#059669"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLIosGIcon);
export default __webpack_public_path__ + "static/media/l_ios_g_icon.92c9a80bad66b65a8cb6ff7470f87c14.svg";
export { ForwardRef as ReactComponent };